import { Box, Container, Divider, IconButton, Stack, useMediaQuery } from "@mui/material"
import { useEffect, useState } from "react";
import MenuDesktop from "./MenuDesktop";
import { MenuMobile, MobMenuList } from "./MenuMob";
import { RoutePaths } from "../../../routes";
import { ReactComponent as GeroiYarIcon } from "../../../icons/GeroiYar.svg"
import { useNavigate } from "react-router";

const links = [
    { label: 'НОВОСТИ', url: RoutePaths.NEWS },
    { label: 'ЭТАПЫ', url: RoutePaths.STEPS },
    { label: 'ПОРЯДОК ОТБОРА', url: RoutePaths.RULES },
    { label: 'ОБЩЕСТВЕННЫЙ СОВЕТ', url: RoutePaths.OB_SOVET },
    { label: 'ПОДДЕРЖКА', url: RoutePaths.SUPPORT },
]

const Header = () => {

    const navigate = useNavigate()
    const isMob = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [open, setOpen] = useState(false)

    useEffect(() => {
        setOpen(false)
    }, [isMob])

    return (
        <>
            {/* <Container maxWidth='xl' disableGutters> */}
            <Container maxWidth='xlp' sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                width: '100%',
                backgroundColor: 'white',
            }}>
                <Stack direction='row' alignItems='center' spacing={2} sx={{
                    height: '91px',
                    backgroundColor: isMob ? 'background.500' : 'none',
                    pl: {
                        xs: 2,
                        lg: 0,
                        xl: 0,
                    },
                    pr: {
                        xs: 2,
                        lg: 0,
                        xl: 0,
                    },
                    // pl: {
                    //     xs: 2,
                    //     lg: 3,
                    //     xl: 0,
                    // },
                    // pr: {
                    //     xs: 2,
                    //     lg: 3,
                    //     xl: 0,
                    // },
                }}>
                    <Box>
                        <IconButton disableRipple sx={{ padding: 0 }}
                            onClick={() => navigate(RoutePaths.HOME)}
                        ><GeroiYarIcon /></IconButton>
                    </Box>

                    {isMob
                        ? <MenuMobile open={open} setOpen={setOpen} />
                        : <MenuDesktop links={links} />
                    }
                </Stack>

                {open && <MobMenuList links={links} />}

                <Divider sx={{ width: '100%' }} />
            </Container>

            
        </>
    )
}

export default Header